import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { setOpenModalExportMedia } from '../../../../../store/modules/articles/actions';
import { selectMediaExport } from '../../../../../store/modules/articles/selectors';
import { useId } from '../../../../../hooks';
import MediaExportTabs from './MediaExportTabs';
import useStyles from './styles';

const MediaExportModal = () => {
  const id = useId();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { open } = useSelector(selectMediaExport);

  const closeHandler = useCallback(() => {
    dispatch(setOpenModalExportMedia(false));
  }, [dispatch]);

  return (
    <Dialog
      open={open}
      onEscapeKeyDown={closeHandler}
      aria-labelledby={id}
      disableBackdropClick
      disablePortal
      maxWidth="sm"
      fullWidth
      style={{ zIndex: 2147483101 }}
      className={classes.noselect}
    >
      <DialogTitle id={id}>
        Downloads & Exports
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={closeHandler}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <MediaExportTabs />
      </DialogContent>
    </Dialog>
  );
};

export default MediaExportModal;
